import React from 'react';
import { GameData } from "../share/game-data.js";
import * as ICONS from "../other/icons.js";
import * as util from "../other/util.js";
import shared from '../share/shared.js'

// The omnipresent resource bar with nice hover-over effects
export default class ResourcesView extends React.Component {
    render() {
        const resources = this.props.resources;
        const production = this.props.production;
        const consumption = this.props.consumption;
        const energy_stats = this.props.energyStats;
        const display = this.props.display || GameData.RESOURCES.map((res) => res.id);
        const storage_capacity = this.props.storageCapacity;
        const housing_capacity = this.props.housingCapacity;
        const workingWorkerCount = this.props.workingWorkerCount;

        return (
            <div>
                <ul className="resource-bar">
                    {/* Regular resources*/}
                    {display.map((id, idx) => {
                        if (id === "worker" && workingWorkerCount !== undefined) {
                            return <WorkerResource key="worker" resources={resources} production={production} consumption={consumption} housingCapacity={housing_capacity} workingWorkerCount={workingWorkerCount} />
                        } else {
                            return (<NormalResource key={idx} resource={GameData.RESOURCE_BY_ID[id]} resources={resources} production={production} consumption={consumption} storageCapacity={storage_capacity} housingCapacity={housing_capacity} />)
                        }
                    })}
                    {energy_stats ? <EnergyResource key="energy" energyStats={energy_stats} /> : null}
                </ul>
            </div>);
    }
}

class NormalResource extends React.Component {
    render() {
        const resource = this.props.resource;
        const amount = this.props.resources[resource.id];
        const properties = [{ name: "Amount", value: Math.floor(amount), color: "white" }];
        let color = "white";

        if (this.props.production) {
            const capacity = this.props.storageCapacity;
            const production = this.props.production[resource.id];
            const consumption = this.props.consumption[resource.id];
            if (capacity === amount) color = "orange";
            const delta = production != null && consumption != null ? production - consumption : undefined;
            if (delta < 0) color = "red";

            properties.push({ name: "Capacity", value: capacity, color: capacity === amount ? "orange" : "white" });
            properties.push({ name: "Production", value: production, color: "white" });
            properties.push({ name: "Consumption", value: consumption, color: "white" });
            properties.push({ name: "Delta", value: delta, color: delta >= 0 ? "green" : "red" });
        }

        return (<li><SingleResource iconId={resource.id} name={resource.ui_name} properties={properties} value={Math.floor(amount)} color={color} /></li>);
    }
}

class WorkerResource extends React.Component {
    render() {
        shared.assert(this.props.production);

        const resource = GameData.RESOURCE_BY_ID["worker"];
        const available_worker_count = this.props.resources[resource.id];
        const capacity = this.props.housingCapacity;
        const working_worker_count = this.props.workingWorkerCount;
        const is_full = (capacity === Math.floor(available_worker_count) + working_worker_count);
        const growth = this.props.production[resource.id];

        const properties = [{ name: "Available", value: Math.floor(available_worker_count), color: "white" }];
        properties.push({ name: "Working", value: working_worker_count, color: "white" });
        properties.push({ name: "Total", value: working_worker_count + Math.floor(available_worker_count), color: "white" });
        properties.push({ name: "Capacity", value: capacity, color: is_full ? "orange" : "white" });
        properties.push({ name: "Production", value: growth, color: "white" });
        properties.push({ name: "Delta", value: is_full ? 0 : growth, color: (capacity === available_worker_count + working_worker_count) ? "orange" : "green" });

        return (<li><SingleResource iconId={resource.id} name={resource.ui_name} properties={properties} value={Math.floor(available_worker_count)} color={is_full ? "orange" : "white"} /></li>);
    }
}

class EnergyResource extends React.Component {
    render() {
        const energy_stats = this.props.energyStats;
        const production = Math.round(energy_stats.production * 10) / 10;
        const consumption = Math.round(energy_stats.consumption * 10) / 10;
        const surplus = production - consumption;
        const efficiency = Math.round(energy_stats.efficiency * 1000) / 10 + "%";

        const properties = [
            { name: "Surplus", value: surplus, color: surplus >= 0 ? "green" : "red" },
            { name: "Production", value: production, color: "white" },
            { name: "Consumption", value: consumption, color: "white" },
            { name: "Efficiency", type: "efficiency", value: efficiency, color: surplus >= 0 ? "green" : "red" },
        ];

        return (<li><SingleResource iconId={"energy"} name={"Energy"} properties={properties} value={surplus} color={surplus >= 0 ? "white" : "red"} /></li>);
    }
}

export class SingleResource extends React.Component {
    render() {
        const icon_id = this.props.iconId;
        const name = this.props.name;
        const properties = this.props.properties;
        const value = this.props.value;
        const color = this.props.color;

        return (
            <div style={{ border: "2px solid gray", display: "inline-block" }}>
                <util.Tooltip tooltip={<util.ListInToolTip name={name} properties={properties} />}>
                    <img className="resource-img" src={ICONS.RESOURCES[icon_id]} alt={name} />
                    <util.ShortNumber style={{ color: color }} number={value} />
                </util.Tooltip>
            </div>);
    }
}
